import { render } from "./ButtonGroup.vue?vue&type=template&id=ebeb6fb0&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import "./ButtonGroup.vue?vue&type=style&index=0&id=ebeb6fb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebeb6fb0"]])

export default __exports__